import { useCallback } from 'react'

import type { BufferEditor } from '../../BufferEditor/types.plate'

type UseEmojiInsertProps = {
  editor: BufferEditor
}

/**
 * Hook for inserting emojis at cursor position in Plate editors.
 *
 * @param editor - Plate editor instance
 * @returns Function that inserts emoji at cursor position
 *
 * @example
 * ```tsx
 * const handleEmojiSelect = useEmojiInsert({ editor })
 * <EmojiPicker onEmojiSelect={handleEmojiSelect} />
 * ```
 */
export const useEmojiInsert = ({
  editor,
}: UseEmojiInsertProps): ((emoji: string) => void) => {
  return useCallback(
    (emoji: string) => {
      if (!editor.api.isFocused()) editor.tf.focus()
      if (!editor.selection) {
        const editorEnd = editor.api.end([])
        if (editorEnd) editor.tf.select({ anchor: editorEnd, focus: editorEnd })
      }
      editor.tf.insertText(`${emoji} `)
    },
    [editor],
  )
}
